import Button from "components/form/Button";
import { AppSectionsContext } from "hooks/AppSectionsContextProvider";
import * as React from "react";
import { ArrowRight } from "react-feather";
import BannerSectionDrawer from "./BannerSectionDrawer";

type Props = {
  onClose: () => void;
};

const Banner: React.FC<Props> = (props) => {
  const context = React.useContext(AppSectionsContext);
  const [visible, setVisible] = React.useState(false);

  return (
    <div className="bg-orange-10 text-center p-5 rounded-2lg">
      <p className="mb-2.5 text-lg font-bold">Banners</p>
      <p className="text-m mb-2.5">
        Banners are amazing allies when you want to share news, information or just promote your social business pages.
        Creativity is the only limit.
      </p>
      <img src="/img/banner-in-app.png" className="mx-auto mb-2.5" />
      <Button size="large" color="green" onClick={() => setVisible(true)}>
        Continue
        <ArrowRight size={24} className="ml-10" />
      </Button>
      {visible && (
        <BannerSectionDrawer
          destroyOnClose
          style={{ transform: "none !important" }}
          isNew={true}
          isVisible={visible}
          onClose={() => {
            setVisible(false);
          }}
          onUpdate={() => {
            props.onClose();
            setVisible(false);
            context.loadSections && context.selectedVenue?.id && context.loadSections(context.selectedVenue?.id, true);
          }}
        />
      )}
    </div>
  );
};

export default Banner;
